import type { FieldProperties } from '@atlassian/jira-project-settings-apps-issue-type-page-product-features/src/common/types/layout-items.tsx';
import { FORGE_FIELD_COLLECTION, FORGE_FIELD_TYPE } from '../../constants.tsx';

/**
 * Forge field types include informations like app installation ID, and because of that we cannot easily use them to determine the field type.
 * This function transforms forge field properties into a simplified forge field type in format: `forge/{type}` or `forge/{type}-{collection}`.
 */
export const transformToSimplifiedForgeFieldType = (properties: FieldProperties): string | null => {
	const forgeType = properties?.[FORGE_FIELD_TYPE];
	const forgeCollection = properties?.[FORGE_FIELD_COLLECTION];

	if (!forgeType) {
		return null;
	}

	if (forgeCollection && forgeCollection !== 'none') {
		return `forge/${forgeType}-${forgeCollection}`;
	}

	return `forge/${forgeType}`;
};
